import React, { useState, useCallback, Component } from 'react';
import ProductsCountTag from '../../../../refresh/organism/ProductsCountTag';
import { getHeight, getWidth } from './utils.js';
import { VideoModalLink } from '../../../common/VideoModal';
import millisecondsToTime from '../../../../utils/dateFormatter';
import { getImageNameForGTMPromotion } from '../../../../modules/ga/gtmLandingPageMethods';
import { gtmPromotionCmsClick, appendItmSourceToURL } from '../../../../modules/ga/GTMdatalayer';
import { formatDuration } from '../../../../utils/banner';
import { addRefParamToUrl, markBannerPlpIfNeeded } from '../../../../utils/jioAdsRelated';
import UTILS from '../../../../utils/jioAdsUtils';
import { showAlertWhenSectionInView } from '../../../../utils/common';
import { sanitize } from '../../header/SearchBar';
import { showModal as showDressToolModal } from '../../../../actions/modal';
import { connect } from 'react-redux';
import { dressToolInitiateInitialFlag, dressToolWithoutFirstStep } from '../../../../actions/shared/braRecommendation';
import screen from '../../../../refresh/constants/pageType.constant';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

class BannerDetailWrapper extends Component {
  constructor(props) {
    super(props);
    const {
      bannerDetails: { timerEndTime }
    } = props;
    const remainingTime = this.getRemainingTime(timerEndTime);
    this.state = {
      remainingTime
    };
  }

  getRemainingTime(timerEndTime) {
    if (timerEndTime) {
      return timerEndTime - new Date().getTime();
    }
    return null;
  }

  componentDidMount() {
    const { remainingTime } = this.state;
    if (!Object.is(remainingTime, null) && remainingTime > 0) {
      this.interVal = setInterval(() => {
        this.setState(
          ({ remainingTime }) => {
            return { remainingTime: remainingTime - 1000 };
          },
          () => {
            if (this.state.remainingTime < 1000) {
              this.setState({ remainingTime: 0 });
              clearInterval(this.interVal);
            }
          }
        );
      }, 1000);
    }
    showAlertWhenSectionInView('timer');
  }

  render() {
    const {
      bannerDetails: { showTimer = false, timerLabel },
      muteTimer = false
    } = this.props;

    const { remainingTime } = this.state;
    if (!showTimer || Object.is(remainingTime, null) || remainingTime <= 0) {
      return <BannerDetail {...this.props} />;
    }
    // if (showTimer && !Object.is(remainingTime, null) && remainingTime <= 0) {
    //   return (
    //     <>
    //       {TimerComponent({ isOfferEnded: true, days, hours, minutes, seconds })}
    //       <BannerDetail {...this.props} />
    //     </>
    //   );
    // }
    let { days, hours, minutes, seconds } = millisecondsToTime(remainingTime);
    return (
      <>
        <div id="timer" aria-hidden="true">
          {/* eslint-disable-next-line no-use-before-define */}
          {TimerComponent({ days, hours, minutes, seconds, timerLabel, muteTimer })}
        </div>
        <BannerDetail {...this.props} />
      </>
    );
  }
}

export function TimerComponent({ days, hours, minutes, seconds, isOfferEnded, timerLabel, muteTimer }) {
  return (
    <div
      className="timer-component timer-component-runtime"
      style={{ position: 'relative', top: '0px', flexDirection: 'column' }}
      aria-hidden={muteTimer}
    >
      {/* {isOfferEnded ? (
        <p
          className="timer-component-wrapper"
          style={{ position: 'relative', top: '10px', zIndex: 10 }}
        >
          Offer Ended
        </p>
     ) : ( */}
      <div
        className="timer-component-wrapper"
        style={{ position: 'relative', top: '10px', zIndex: 10 }}
        aria-label={`${timerLabel || 'Ends in'} ${days !== '00' ? `${days} days` : ''} ${
          hours !== '00' ? `${hours} hours` : ''
        } ${minutes} minutes ${seconds} seconds`}
      >
        <strong>
          {timerLabel || 'Ends in'}
          {days !== '00' && (
            <span>
              <span className="time-counter">{days}</span>
              <span className="label">d</span>
            </span>
          )}
          {hours !== '00' && (
            <span>
              <span className="time-counter">{hours}</span>
              <span className="label">h</span>
            </span>
          )}
          <span className="time-counter">{minutes}</span>
          <span className="label"> m</span>
          <span className="time-counter">{seconds}</span>
          <span className="label">s</span>
        </strong>
      </div>
      {/* )} */}
      <div
        style={{
          background: '#fff8eb',
          width: '30px',
          height: '30px',
          top: '7px',
          transform: 'rotateY(0deg) rotate(45deg)',
          position: 'relative'
        }}
      />
    </div>
  );
}

function BannerDetail(props) {
  const {
    bannerDetails: {
      bannerUrl,
      openInNewTab,
      altText,
      width,
      height,
      subComponents,
      texts,
      hotspots,
      products,
      dynamicPageMetadata = {},
      ctaSettings = {},
      videoSettings = {},
      audioSettings = {},
      bannerType,
      enableAdsOnPlp = true,
      isAdBanner = false,
      isJioAdBanner = false,
      clickthrough = '',
      clicktracker = '',
      impression = '',
      cid = '',
      desc = '',
      bannerCategory = ''
    },
    bannerDetails,
    heading,
    fitToWidth,
    isSlider,
    rowType,
    showModal,
    customWidth,
    allBanners,
    index: currentBannerInRow,
    rowNumber,
    isLuxe,
    showDressModal,
    initiateInitialFlag,
    initiateWithoutFirstFlag
  } = props;
  let jioAdsBanner = [];
  let setJioAdsBanner = false;
  if (isAdBanner && isJioAdBanner && clickthrough) setJioAdsBanner = true;
  if (setJioAdsBanner) {
    jioAdsBanner[0] = {
      height: 100,
      hotspotUrl: clickthrough,
      type: 'HOTSPOT',
      width: 100,
      x: 0,
      y: 0,
      isJioAds: true,
      clicktracker, // change if Spell mistake in response
      jioAdsImpression: impression,
      jioAdsCid: cid,
      jioAdsDesc: desc
    };
  }
  const [allowChildRender, setAllowChildRender] = useState(false);

  const { duration = 0 } = dynamicPageMetadata;

  const renderChilds = useCallback(() => {
    setAllowChildRender(true);
  });

  let wd;
  let hgt;
  wd = getWidth(width, height);
  hgt = getHeight(fitToWidth, width, height);
  const { href } = window.location;
  let hash = '';
  let hashIndex = href.indexOf('#');
  if (hashIndex > 0) hash = href.substring(hashIndex + 1);
  return (
    <div
      role="presentation"
      className="banner-detail"
      style={{
        width: `100%`,
        verticalAlign: 'bottom'
      }}
      onClick={() => {
        if (rowType === 'SHOPTHELOOK') {
          if (hash !== 'ShopTheLook') localStorage.removeItem('shopTheLookYPos');
          showModal('banner-modal', {
            state: {
              products,
              dynamicPageMetadata,
              allBanners,
              currentBannerInRow,
              variant: 'desktop',
              rowNumber,
              dynamicPageMetadata,
              bannerType
            }
          });
        }
      }}
    >
      <div className={`${!isLuxe ? 'img-animate' : ''}`} style={{ width: '100%', display: 'flex' }}>
        {renderBannerMainImage(
          openInNewTab,
          hotspots,
          wd,
          hgt,
          bannerUrl,
          altText,
          renderChilds,
          bannerDetails,
          heading,
          rowNumber,
          currentBannerInRow,
          bannerCategory
        )}
        <SubComponents
          bannerCategory={bannerCategory}
          allowChildRender={allowChildRender}
          subComponents={subComponents}
          texts={texts}
          hotspots={setJioAdsBanner ? jioAdsBanner : hotspots}
          openInNewTab={openInNewTab}
          enableAdsOnPlp={enableAdsOnPlp}
          bannerDetails={bannerDetails}
          bannerUrl={bannerUrl}
          rowNumber={rowNumber}
          currentBannerInRow={currentBannerInRow}
          altText={altText}
          showDressModal={showDressModal}
          initiateInitialFlag={initiateInitialFlag}
          initiateWithoutFirstFlag={initiateWithoutFirstFlag}
        />
        {rowType === 'SHOPTHELOOK' ? (
          <ProductsCountTag products={products} variant="desktop" content="productCount" />
        ) : null}
        {rowType === 'SHOPTHELOOK' && dynamicPageMetadata?.mediaType === 'VIDEO' ? (
          <ProductsCountTag
            variant="desktop"
            content="videoDuration"
            duration={formatDuration(Number(duration))}
          />
        ) : null}
      </div>
    </div>
  );
}

function renderBannerMainImage(
  openInNewTab,
  hotspots,
  wd,
  hgt,
  bannerUrl,
  altText,
  renderChilds,
  bannerDetails = {},
  heading = null,
  rowNumber = 0,
  currentBannerInRow = 0,
  bannerCategory
) {
  let position = currentBannerInRow !== 0 ? `${rowNumber}/${currentBannerInRow}` : rowNumber;
  const {
    isAdBanner = false,
    isJioAdBanner = false,
    clickthrough = '',
    cid = '',
    desc = ''
  } = bannerDetails;
  let setJioAdsBanner = false;
  if (isAdBanner && isJioAdBanner && clickthrough) setJioAdsBanner = true;
  return (
    <a
      src="/"
      data-ga-event-category={bannerDetails.bannerType}
      data-gtm-bnr-position={position}
      data-gtm-bnr-width={bannerDetails?.width}
      data-gtm-bnr-height={bannerDetails?.height}
      data-gtm-bnr-imgname={getImageNameForGTMPromotion(bannerUrl)}
      data-gtm-bnr-id={bannerDetails.uuid || ''}
      data-gtm-bnr-isjioads={setJioAdsBanner}
      data-gtm-bnr-jioads-cid={setJioAdsBanner ? cid : ''}
      data-gtm-bnr-jioads-desc={setJioAdsBanner ? desc : ''}
      data-gtm-bnr-sclid={bannerDetails?.sclid || ''}
      data-gtm-bnr-uclid={bannerDetails?.uclid || ''}
      data-gtm-bnr-clientid={bannerDetails?.client_id || ''}
      target={openInNewTab ? '_blank' : '_self'}
      style={{ cursor: 'auto', width: '100%' }}
      aria-label={altText ? altText : 'banner-image'}
      {...(bannerCategory === "HEADER" ? {
        'role': "heading",
        'aria-level': 2
      } : {
        'role': 'img'
      })}
      {...((hotspots?.length) < 2) &&  {...((((bannerCategory === "DECORATIVE") || (hotspots?.length > 0)) && (bannerCategory !== "HEADER")) && {
          'aria-hidden': "true",
      })}}
    >
      <img
        name="main-banner"
        style={{
          position: 'relative',
          width: '100%',
        }}
        aria-hidden="true"
        src={replaceWithJioCDN(bannerUrl)}
        alt={(bannerCategory === "DECORATIVE") ? "" : (altText ? altText : 'banner-image')}
        onLoad={renderChilds}
      />
    </a>
  );
}

export function SubComponents({
  bannerCategory,
  allowChildRender,
  subComponents,
  texts,
  hotspots,
  enableAdsOnPlp,
  openInNewTab,
  bannerDetails,
  bannerUrl,
  currentBannerInRow,
  rowNumber,
  altText,
  showDressModal,
  initiateInitialFlag,
  initiateWithoutFirstFlag
}) {
  let position = currentBannerInRow !== 0 ? `${rowNumber}/${currentBannerInRow}` : rowNumber;
  const { location = {} } = window;
  let path = location.pathname.includes('/shop')
    ? 'lp'
    : location.pathname.includes('/c') ||
      location.pathname.includes('/s') ||
      location.pathname.includes('/p')
    ? 'plp'
    : 'lp';
  return (
    <>
      {allowChildRender &&
        subComponents.map(({ imageUrl, width, height, x, y }, index) => (
          <img
            key={index}
            style={{
              position: 'absolute',
              left: `${x}%`,
              top: `${y}%`,
              width: `${width}%`,
              height: `${height}%`
            }}
            src={replaceWithJioCDN(imageUrl)}
          />
        ))}
      {allowChildRender &&
        texts.map(({ value, fontFamily, fontSize, colour: color, x, y }, index) => (
          <span
            key={index}
            style={{
              position: 'absolute',
              left: `${x}%`,
              top: `${y}%`,
              font: ` ${fontSize} ${fontFamily}`,
              color
            }}
          >
            {value}
          </span>
        ))}

      {allowChildRender &&
        [...hotspots]
        .sort((a, b) => {
          return a.x - b.x;
        })
        .map(
          (
            {
              hotspotUrl,
              width,
              height,
              x,
              y,
              type,
              metadata,
              isJioAds = false,
              clicktracker = '',
              jioAdsImpression = '',
              jioAdsCid = '',
              jioAdsDesc = '',
              altText : tempAltText
            },
            index
          ) => {
            hotspotUrl = addRefParamToUrl(enableAdsOnPlp, hotspotUrl);
            const seperator = hotspotUrl.indexOf('?') >= 0 ? '&' : '?';
            const ccb = isJioAds ? UTILS.getCCB(jioAdsDesc) : '';
            if (type === 'VIDEO') {
              return (
                <VideoModalLink
                  hotspotUrl={hotspotUrl}
                  width={width}
                  metadata={metadata}
                  height={height}
                  x={x}
                  y={y}
                />
              );
            }
            return (
              <a
                key={index}
                aria-label={hotspots?.length < 2 && bannerCategory !== 'HEADER' ? 
                  (tempAltText !== undefined && tempAltText && tempAltText !== 'NA') ? `${tempAltText} with graphic ${altText}`:`graphic ${altText}` 
                  : `${tempAltText || 'banner Image'}`}
                target={openInNewTab ? '_blank' : '_self'}
                style={{
                  position: 'absolute',
                  left: `${x}%`,
                  top: `${y}%`,
                  width: `${width}%`,
                  height: `${height}%`
                }}
                onClick={(e) => {
                  markBannerPlpIfNeeded(hotspotUrl);
                  sessionStorage.setItem('cmsFlagBannerAds', `${enableAdsOnPlp}`);
                  if (hotspotUrl.toLowerCase().includes('dresstool')) {
                    e.preventDefault();
                    showDressModal('dress-tool-modal');
                    initiateInitialFlag();
                    sessionStorage.setItem('dressToolIngressDetails', JSON.stringify({IngressPoint:'homescreen', BannerName:bannerDetails?.altText}));
                  }
                }}
                data-gtm-bnr-id={bannerDetails.uuid || ''}
                data-ga-event-category={bannerDetails?.bannerType}
                data-gtm-bnr-position={position}
                data-gtm-bnr-width={bannerDetails?.width}
                data-gtm-bnr-height={bannerDetails?.height}
                data-gtm-bnr-sclid={bannerDetails?.sclid || ''}
                data-gtm-bnr-uclid={bannerDetails?.uclid || ''}
                data-gtm-bnr-clientid={bannerDetails?.client_id || ''}
                data-gtm-bnr-imgname={getImageNameForGTMPromotion(bannerUrl)}
                data-gtm-bnr-isjioads={isJioAds}
                data-gtm-bnr-jioads-cid={isJioAds ? jioAdsCid : ''}
                data-gtm-bnr-jioads-impression={isJioAds ? jioAdsImpression : ''}
                data-gtm-bnr-jioads-clicktracker={isJioAds ? clicktracker : ''}
                data-gtm-bnr-jioads-desc={isJioAds ? jioAdsDesc : ''}
                // href={isJioAds?`/c/83?ref=cmsBanner&sourcePage=jio ads ${path}&jioAdsSource=jioads - ${jioAdsDesc} - ${jioAdsCid}`:'/c/83?ref=cmsBanner'}
                href={
                  // add sanaitise check here
                  hotspotUrl.includes('jio-engage')
                    ? '/'
                    : isJioAds
                    ? sanitize(`${hotspotUrl}${seperator}sourcePage=jio ads ${path}&jioAdsSource=jioads - ${jioAdsDesc} - ${jioAdsCid.replaceAll(
                        '[ccb]',
                        ccb
                      )}`)
                    : appendItmSourceToURL(sanitize(hotspotUrl), {
                        itm_source: 'banner',
                        itm_source_detail:
                          getImageNameForGTMPromotion(bannerUrl) || altText || tempAltText || ''
                      })
                }
                rel="noreferrer"
              />
            );
          }
        )}
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    showDressModal: (name, config) => {
      dispatch(showDressToolModal(name, config));
    },
    initiateInitialFlag: () => dispatch(dressToolInitiateInitialFlag()),
    initiateWithoutFirstFlag: () => dispatch(dressToolWithoutFirstStep()),
    
  };
};

// export default BannerDetailWrapper;
export default connect(null, mapDispatchToProps)(BannerDetailWrapper);
